import { createFileRoute } from "@tanstack/react-router";
import { ContentPage } from "@/components/seo/content-page";
import { seoMeta } from "@/lib/seo/head";

export const Route = createFileRoute("/belead")({
  head: () =>
    seoMeta({
      title: "BeLead - studio che progetta prodotti digitali e AI",
      description:
        "BeLead progetta e sviluppa prodotti digitali e applicazioni di intelligenza artificiale, tra cui LexAIPro, piattaforma di AI giuridica per professionisti legali.",
      path: "/belead",
    }),
  component: () => (
    <ContentPage
      eyebrow="Studio"
      title="BeLead: prodotti digitali progettati per essere usati davvero"
      lead="Siamo lo studio che ha progettato e sviluppato LexAIPro. Lavoriamo su prodotti digitali e applicazioni di intelligenza artificiale, dalla strategia all'interfaccia fino all'infrastruttura."
      breadcrumbs={[
        { name: "Home", path: "/" },
        { name: "BeLead", path: "/belead" },
      ]}
      sections={[
        {
          heading: "Come lavoriamo",
          body:
            "Partiamo dal problema concreto di chi userà il prodotto, non dalla tecnologia. Progettiamo interfacce sobrie, misurabili e accessibili, e costruiamo il backend perché resti manutenibile nel tempo.",
          bullets: [
            "Ricerca sul contesto d'uso e definizione dello scope",
            "Design system e interfacce responsive accessibili",
            "Sviluppo full-stack, integrazioni AI e infrastruttura dati",
            "Misurazione, iterazione e manutenzione dopo il lancio",
          ],
        },
        {
          heading: "Progetti",
          body:
            "LexAIPro è il nostro progetto principale: una piattaforma di intelligenza artificiale per professionisti legali italiani, con ricerca giuridica, analisi documentale e redazione assistita, dove ogni risposta è collegata alla fonte da cui deriva.",
          bullets: [
            "LexAIPro - AI giuridica tracciabile per avvocati, studi e uffici legali",
          ],
        },
        {
          heading: "Cosa ci guida",
          body:
            "Preferiamo prodotti che spiegano il proprio funzionamento a prodotti che promettono magia. Tracciabilità, chiarezza del linguaggio e rispetto dei dati delle persone sono requisiti di progetto, non aggiunte finali.",
        },
        {
          heading: "Parliamone",
          body:
            "Se stai valutando un prodotto digitale o un'applicazione AI, raccontaci il contesto: rispondiamo con una lettura onesta di cosa serve e cosa no.",
          bullets: ["be-lead.org", "beleadcreativestudio@proton.me"],
        },
      ]}
      cta={{ label: "Contattaci", to: "/contatti" }}
      updated="2026"
    />
  ),
});
